import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles, THEME_VARIANTS } from 'core/components/theme/theme-variant';

export default makeStyles((theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.panel_background,
    overflow: 'hidden'
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    paddingRight: 32,
    paddingLeft: 32,
    paddingTop: 24,
    paddingBottom: 24,
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, { ...theme.cardStyles.outlined, margin: 0, width: '100%' })
  },
  compactCoverage: {
    '&&': {
      padding: 0,
      border: 0,
      boxShadow: 'none',
      backgroundColor: theme.colorPalette.white
    }
  },
  additionalCoverages: {
    backgroundColor: theme.colors.card_background_secondary,
    paddingRight: 16,
    paddingLeft: 16,
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, theme.cardStyles.body)
  },
  coverageAmount: {
    marginTop: 6
  },
  coverageLabel: {
    paddingTop: 4
  },
  umbrellaLabel: {
    color: theme.onCard.beige_50
  },
  umbrellaContent: {
    marginTop: 28
  },
  coverageContainer: {
    paddingTop: '24px !important' // override the grid spacing
  },
  errorMessage: {
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colors.red_light : '#f44336',
    textTransform: 'none',
    fontSize: 10
  },
  noPaddingTop: {
    marginTop: 0,
    position: 'relative',
    top: -10
  },
  link: {
    color: theme.colorPalette.orange_50,
    textDecoration: 'underline !important'
  },
  sppLinkButton: {
    composes: '$link',
    fontSize: 12,
    padding: theme.spacing(0),
    marginBottom: theme.spacing(0.4)
  },
  // A dark button in both looks, so its label stays white.
  button: {
    ...reskinStyles(theme, {
      '&&': { backgroundColor: theme.colorPalette.green_100, color: theme.colorPalette.white },
      '&&:hover': { backgroundColor: theme.colorPalette.green_90, color: theme.colorPalette.white }
    }),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    minWidth: 150
  },
  buttonLink: {
    color: theme.colorPalette.white
  },
  purchasedContainer: {
    backgroundColor: theme.colorPalette.white_op_15,
    padding: 16,
    borderRadius: theme.sizes.innerCorners
  },
  outlineContainer: {
    border: `2px solid ${theme.onCardDivider.green_80}`,
    boxShadow: 'none',
    paddingLeft: theme.spacing(4),
    ...reskinStyles(theme, theme.cardStyles.body)
  },
  infoIcon: {
    height: 16,
    width: 16
  },
  notificationCard: {
    padding: theme.spacing(10)
  },
  notificationCardText: {
    fontSize: 12,
    padding: theme.spacing(6, 1, 6, 2)
  },
  cardSubSectionDivider: {
    borderTop: `1px solid ${theme.onCardDivider.beige_25_op_30}`,
    paddingTop: theme.spacing(4)
  },
  cardSubSectionTitle: {
    paddingBottom: theme.spacing(4),
    fontSize: 14,
    color: theme.colorPalette.beige_75
  },
  lockedRoofSurface: {
    marginTop: theme.spacing(4)
  },
  spacingOnBottomForDescription: {
    marginBottom: theme.spacing(8)
  },
  // #35617: shown next to a locked Coverage A limit for a non-authority user.
  coverageLimitLockWarning: {
    marginTop: theme.spacing(1),
    color: theme.colors.error
  }
}));
